import React from 'react';
import styled from "styled-components";
import {Grid} from "@mui/material";
import {Colors} from "../theme/colors";
import logoColor from "../img/logo-color.png";

const NotAuthHeader: React.FC<any> = () => {
    return (
        <StyledNotAuthHeader item container direction={"row"} xs="auto">
            <Grid item>
                <StyledLogo src={logoColor} alt="Logo"/>
            </Grid>
            <Grid item>

            </Grid>
        </StyledNotAuthHeader>
    );
}

const StyledNotAuthHeader = styled(Grid)`
  height: 80px;
  border-bottom: 1px solid ${Colors.secondary95};
  background: ${Colors.neutral98};
`;

const StyledLogo = styled('img')`
  margin-top: 22px;
  height: 42px;
  margin-left: 1.5rem;
`;

export default NotAuthHeader;